import { render } from "./ApplicationsView.vue?vue&type=template&id=74714068"
import script from "./ApplicationsView.vue?vue&type=script&lang=js"
export * from "./ApplicationsView.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/Vakifbank-Vue-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__